import { useState } from "react";
import styled from "styled-components";
import { motion } from "framer-motion";
import { headerAnimate } from "../animation";
import MobileNav from "./MobileNav";

const Header = () => {
  const [mobileOpen, setMobileOpen] = useState(false);

  const mobileNavHandler = () => {
    setMobileOpen(!mobileOpen);
  };

  mobileOpen
    ? document.body.classList.add("fixed")
    : document.body.classList.remove("fixed");

  return (
    <StyledHeader>
      <Nav variants={headerAnimate} initial="hide" animate="show">
        <h4>Irétọ̀míwá</h4>
        <ul>
          <a href="#about">
            <li>About</li>
          </a>
          <a href="#skills">
            <li>Skills</li>
          </a>
          <a href="#projects">
            <li>Projects</li>
          </a>
          <a href="#contact">
            <li>Contact</li>
          </a>
        </ul>
        <MenuBar className={mobileOpen && "active"} onClick={mobileNavHandler}>
          <span></span>
          <span></span>
          <span></span>
        </MenuBar>
        {mobileOpen && <MobileNav setMobileOpen={setMobileOpen} />}
      </Nav>
    </StyledHeader>
  );
};

const StyledHeader = styled(motion.header)`
  width: 100%;
  height: 12vh;
`;

const Nav = styled(motion.nav)`
  width: 85%;
  margin: 0 auto;
  padding-top: 2rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  ul {
    display: flex;
    align-items: center;
    li {
      font-weight: 500;
      padding-bottom: 0.4rem;
      margin-left: 3rem;
      position: relative;
      &::before {
        position: absolute;
        bottom: 0;
        left: 0;
        content: "";
        width: 0%;
        height: 0.2rem;
        background-color: #d6e5fa;
        transition: width 0.2s ease-in;
      }

      &:hover {
        color: #d6e5fa;
        &::before {
          width: 100%;
        }
      }
    }
  }

  @media screen and (max-width: 768px) {
    justify-content: center;
    h4 {
      font-size: 1.6rem;
    }
    ul {
      display: none;
    }
  }
`;

const MenuBar = styled.div`
  display: none;
  z-index: 50;
  cursor: pointer;
  transition: all 0.3s linear;
  span {
    background-color: #aaaaaa;
    display: block;
    width: 28px;
    height: 2px;
    border-radius: 9999px;
    transition: all 0.3s ease-in-out;
    &:not(:last-child) {
      margin-bottom: 7px;
    }
  }
  &.active {
    transition-delay: 0.8s;
    transform: rotate(45deg);
    span:nth-child(2) {
      width: 0;
    }
    span:nth-child(1),
    span:nth-child(3) {
      transition-delay: 0.4s;
    }
    span:nth-child(1) {
      transform: translateY(9px);
    }
    span:nth-child(3) {
      transform: translateY(-9px) rotate(90deg);
    }
  }

  /* @media screen and (max-width: 768px) {
    display: block;
  } */
`;

export default Header;
